import cardLargeListTemplate from '../templates/cardLargeList.hbs';
import $ from 'jquery';

/**
 * Card Class
 * @param {Object} data
 *      data.icon = font-awesome class for card icon
 *      data.img || data.image = url for card visual image
 *      data.url = link for title portion of card
 *      data.title = link text for url
 *      data.status = status indicator for the card ['published', 'draft']
 * @returns {Object} jQuery
 */
$.fn.sdaCardLargeList = function(data) {
    const that = this;
    const $mediaContent = $(that.find('.media-content:first')).clone();
    const $footerBtns = $(that.find('.sda-card-footer:first')).clone();

    if (that.is('[data-compiled]')) {
        return that;
    }

    data = data || {};
    $.extend(data, that.data());

    if (that.hasClass('sda-card-large-list')) {
        data.statusCard = true;
        data.noStatus = true;
    }

    that.html($(cardLargeListTemplate(data)))
        .find('.sda-status-card:first')
        .sdaStatusCard(data);

    if ($footerBtns && $footerBtns.length) {
        that.append($footerBtns);
    }

    if ($mediaContent && $mediaContent.length) {
        that.find('.card-media:first').append($mediaContent);
    }

    that.attr('data-compiled', '');

    return that;
};
